import React from "react";
import { useNavigate, NavLink } from "react-router-dom";

import chevronLeft from "./assets/chevron left.svg";
import { useBrand } from "../context/BrandContext";
import defaultAppLogo from "../assets/smarttt-default-logo.png";
import { resolveClubImageUrl } from "../utils/resolveClubImageUrl";
import "./AdminLayout/AddGroup.css";

function resolveLogoHomePath() {
  try {
    const u = JSON.parse(localStorage.getItem("user") || "{}");
    if (u?.isSuperAdmin || u?.type_user_id === 1 || u?.type_user_id === 2) return "/Dashboard";
    const roles = u?.all_role_names;
    if (Array.isArray(roles) && (roles.includes("Admin") || roles.includes("Super Admin"))) {
      return "/Dashboard";
    }
  } catch {
    /* ignore */
  }
  return "/home";
}

export const AddHeader = ({ title = "Add Exercise" }) => {
  const navigate = useNavigate();
  const { brand } = useBrand();
  const logoSrc = resolveClubImageUrl(brand?.logo_url) || defaultAppLogo;
  const brandName = brand?.brand_name || brand?.brand_short_name || "Club";
  const logoHomeTo = resolveLogoHomePath();

  const goBack = () => {
    navigate(-1);
  };

  return (
    <div className="exercise-header">
      <button type="button" onClick={goBack} className="back-btn">
        <img src={chevronLeft} alt="" />
      </button>
      <h2>{title}</h2>
      <NavLink to={logoHomeTo} className="exercise-header-club-brand" title={brandName}>
        <img src={logoSrc} alt="" className="exercise-header-club-logo" />
      </NavLink>
    </div>
  );
};
